import { injectWindow } from '@cosmos/util-common/di';

import { buildResetUrl } from './reset-url';

/**
 * Returns a function that navigates to `/latest`. Uses a full-page navigation
 * (not the Angular router) so the early-bootstrap reset runs, wipes SW +
 * caches, and then restores the user via the `return` query param. Uses
 * `location.replace` so neither `/latest` nor the stale page lingers in
 * history — the net effect on history matches the plain `location.reload()`
 * the old reset used.
 */
export function injectNavigateToLatest(): () => void {
  const win = injectWindow();
  return () => {
    win.location.replace(buildResetUrl(win));
  };
}
